import Ajax from "base/Ajax";
import CookieHelper from "base/CookieHelper";
import EventEmitter from "base/EventEmitter";
import { admin_svg_include } from "base/functions";
import ValueHelper from "base/ValueHelper";
import "blueimp-file-upload";
import "blueimp-file-upload/js/jquery.fileupload-process";
import { FileDetailsModal } from "files/FileDetailsModal";

class FileUploader extends EventEmitter {
    constructor($button, $progressHolder = null, $dropzone = null, settings = {}) {
        super();

        this.settings = $.extend(true, {}, FileUploader.DEFAULT_SETTINGS, settings);

        if (Array.isArray(this.settings.extensions) && this.settings.extensions.length > 0) {
            this.settings.accept = this.settings.extensions.map((ext) => '.' + ext).join(',');
        }

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);

        this.files = [];
        this.uploadingRequests = {};
        this.removedFiles = {};

        this.$button = $button;
        this.$progressHolder = $progressHolder;
        this.$dropzone = $dropzone;

        this.$originalElement = null;
        this.$draggingElement = null;

        this.createFileUploader();
        this.bindEvents();
    }

    get $file() {
        return this.fileupload.element;
    }

    bindEvents() {
        const me = this;
        if (this.$progressHolder !== null) {
            this.$progressHolder.on("click", ".js-retry", function () {
                let data = $(this).closest(".js-file-item").data("context");
                // Reset attempts counter
                data.context.data("attempts", 0);
                me.startFileUpload(data);

                return false;
            }).on("click", ".js-remove", function () {
                me.removeFile($(this).parents(".js-file-item").data("file"));

                return false;
            }).on("mousedown", ".js-drag-element", function (e) {
                return me.handleMouseDown($(this).parent('.js-orderer-item'), e);
            }).on("mousedown", ".js-remove", function (e) {
                e.stopPropagation();
            }).on("click", ".js-edit-details", function () {
                let activeFile = $(this).parents(".js-file-item").data("file");
                let modal = new FileDetailsModal(activeFile);

                modal.on('update', (data) => {
                    me.files = me.files.map((file) => {
                        if (activeFile.id === file.id) {
                            file.name = ('undefined' !== typeof data.name && data.name.trim().length > 0) ? data.name : file.name;
                            file.label = ('undefined' !== typeof data.label && data.label.trim().length > 0) ? data.label : file.label;
                            file.fullName = file.name + '.' + file.extension;

                            file.$progress.find('.js-full-name').after(me.buildFullNameElement(file)).remove();
                        }
                        return file;
                    });

                }).on('hide', () => {
                    me.emit("fileDetailsModalClosed");
                });

                modal.show();
                return false;
            });
        }
        this.$button.on("click", () => {
            this.$file.click();
            return false;
        });
    }

    destroy() {
        if (this.$file) this.$file.remove();

        super.destroy();
    }

    handleAddedFile(e, data) {
        data.ID = FileUploader.CURRENT_ID++;

        let file = data.files[0];

        let nameParts = file.name.split(".");
        let extension = '';
        if (nameParts.length > 1) {
            extension = nameParts.pop();
        }

        let name = nameParts.join('.');
        let fileData = {
            name: name,
            label: name,
            extension: extension,
            fullName: name + (extension.length > 0 ? '.' + extension : ''),
            size: file.size,
        };
        fileData = this.addFile(fileData);
        data.context = fileData.context;
        data.context.data("request", data);
        data.context.data("context", data);
        data.emitter = fileData.emitter;

        if (!this.emit(EVENT_FILE_ADDED, {
            file,
            data,
            fileData,
            emitter: fileData.emitter,
        })) {
            data.context.addClass(this.settings.classes.base + "--error").find(".js-indicator").css("width", "100%");
            data.context.find(".js-buttons").html([
                eotwJSXFactory('button', {className: this.settings.classes.base + "__btn js-remove", type: "button"}, [
                    eotwJSXFactory('span', {className: this.settings.classes.base + "__icon", unsafehtml: admin_svg_include('error')})
                ]),
            ]);
            return;
        }

        this.fileupload.process(data).done(async () => {
            file = data.files[0];
            data.context.find(".js-file-size").html(ValueHelper.format_bytes(file.size));
            this.startFileUpload(data);
        });
    }

    handleSubmitFile(e, data) {
        if (this.removedFiles[data.ID]) {
            return;
        }
        this.uploadingRequests[data.ID] = data;
        this.checkUploadingRequests();

        data.formData = {
            csrf: CookieHelper.get('csrf'),
        };
    }

    checkUploadingRequests() {
        if (Object.keys(this.uploadingRequests).length > 0) {
            this.emit(EVENT_UPLOADING);
        } else {
            this.emit(EVENT_DONE);
        }
    }

    handleDoneUpload(e, data) {
        let response = data.result;

        if (response.success === true) {
            this.handleSuccessfulUpload(data);
        } else {
            delete this.uploadingRequests[data.ID];
            console.warn("Couldn't upload image", response);
            this.displayError(data.context);

            this.emit(EVENT_FILE_ERROR, {
                message: response.message,
                file: data,
            });
            data.emitter.emit(EVENT_FILE_ERROR, {
                message: response.message,
                file: data,
            });
        }
        this.checkUploadingRequests();
    }

    async handleSuccessfulUpload(data) {
        try {
            if (this.removedFiles[data.ID]) {
                // This file haas been cancelled, don't do anything more
                this.checkUploadingRequests();
                return;
            }

            let file = await Ajax.post("files", '', {
                "chunked-upload": data.context.data("chunkedUpload").id,
            }, window.User ? Ajax.ADMIN : Ajax.WEBSITE);

            if (this.removedFiles[data.ID]) {
                // This file haas been cancelled, don't do anything more
                this.checkUploadingRequests();
                return;
            }

            this.emit(EVENT_FILE_UPLOADED, file);
            data.emitter.emit(EVENT_FILE_UPLOADED, file);

            $.extend(data.context.data("file"), file);
            this.emit(EVENT_CHANGE);

            delete this.uploadingRequests[data.ID];
            this.displaySuccess(data.context);
        } catch (e) {
            delete this.uploadingRequests[data.ID];

            console.error("Couldn't finish upload", e);
            this.displayError(data.context);
            this.emit(EVENT_FILE_ERROR, {
                message: e.message,
                file: data,
            });
            data.emitter.emit(EVENT_FILE_ERROR, {
                message: e.message,
                file: data,
            });
        }

        this.checkUploadingRequests();
    }

    getFiles() {
        return this.files.filter((file) => file.id).map((file) => {
            file = $.extend({}, file);

            delete file.$progress;
            delete file.$context;
            delete file.context;
            delete file.emitter;

            return file;
        });
    }

    handleFailedUpload(e, data) {
        let attempts = data.context.data("attempts");
        if (attempts < 6) {
            console.warn("Chunk failed, retrying", attempts);
            setTimeout(() => {
                this.startFileUpload(data);
            }, attempts * 200);
            return;
        }

        delete this.uploadingRequests[data.ID];
        this.checkUploadingRequests();

        this.displayError(data.context);

        let text = data.jqXHR.responseText;
        let message = "Connection error";
        console.error("Connection error", e, data, text);

        try {
            let jsonData = JSON.parse(text);
            if (jsonData.message) {
                message = jsonData.message;
            }
        } catch (e) {
            //Noop
        }

        this.emit(EVENT_FILE_ERROR, {
            message: message,
            file: data,
        });
        data.emitter.emit(EVENT_FILE_ERROR, {
            message: message,
            file: data,
        });
    }

    createFileUploader() {
        let $file = eotwJSXFactory('input', {className: "js-no-validate", type: "file", style: "display:none;", multiple: this.settings.allowMultiple, accept: this.settings.accept});
        this.$button.after($file);

        $file.fileupload($.extend(true, {}, {
            dataType: 'json',
            paramName: 'file',
            maxChunkSize: this.settings.chunkSize,
            add: this.handleAddedFile.bind(this),
            submit: this.handleSubmitFile.bind(this),
            progress: this.handleProgress.bind(this),
            done: this.handleDoneUpload.bind(this),
            fail: this.handleFailedUpload.bind(this),
            chunkbeforesend: (e, data) => {
                // Update CSRF token for this request
                data.formData['csrf'] = CookieHelper.get('csrf');
            },
            chunkdone: (e, data) => {
                // Update the stored chunked data
                data.context.data("chunkedUpload", data.result.data);
            },
            dropZone: this.$dropzone,
            loadImageMaxFileSize: null,
        }, this.settings.uploaderSettings));

        this.fileupload = $file.data("blueimpFileupload");
    }

    setFiles(files) {
        this.files.forEach((file) => {
            file.emitter.emit(EVENT_FILE_REMOVED);
            file.$progress.remove();
        });

        this.files = [];

        files.forEach((file) => {
            this.addFile(file);
        });
    }

    removeFile(file) {
        if (!this.settings.allowRemoving && file.id) return;
        if (file.emitter) {
            file.emitter.emit(EVENT_FILE_REMOVED);
        }
        let data = file.context.data("context");

        file.context.remove();

        this.files = this.files.filter((other) => other !== file);

        if (data) {
            if (this.uploadingRequests[data.ID]) {
                data.abort();
            }
            delete this.uploadingRequests[data.ID];
            this.removedFiles[data.ID] = true;
        }

        this.emit(EVENT_CHANGE);
        this.checkUploadingRequests();
    }

    addFile(file) {
        file = $.extend(true, {}, file);

        let $progress = this.createProgressRow(file);
        if (this.$progressHolder !== null) {
            this.$progressHolder.append($progress);
        }
        file.context = $progress;
        file.$progress = $progress;
        file.emitter = new EventEmitter();

        this.files.push(file);
        this.emit(EVENT_CHANGE);

        if (file.id) {
            this.emit(EVENT_EXISTING_FILE_ADDED, file);
        }
        return file;
    }

    createProgressRow(file) {
        if (this.$progressHolder === null) {
            return (eotwJSXFactory('div')).data("file", file);
        }

        return (
            eotwJSXFactory('div', {className: this.settings.classes.base + " js-file-item " + (file.id ? this.settings.classes.base + "--done " + this.settings.classes.base + "--progress-hidden " : "") + (this.settings.allowOrdering ? this.settings.classes.base + "--ordering js-orderer-item" : undefined), 'data-id': file.id}, [
                eotwJSXFactory('div', {className: this.settings.classes.base + "__indicator js-indicator"}),
                this.settings.allowOrdering ? (eotwJSXFactory('button', {type: "button", className: this.settings.classes.base + '__drag js-drag-element'})) : undefined,
                eotwJSXFactory('div', {className: this.settings.classes.base + "__content"}, [
                    this.buildFullNameElement(file),
                    eotwJSXFactory('span', null, ["File size: ", eotwJSXFactory('span', {className: "js-file-size"}, [ValueHelper.format_bytes(file.size)])]),
                    eotwJSXFactory('div', {className: this.settings.classes.base + "__buttons js-buttons"}, [
                        file.id && this.settings.allowEditFileName ? eotwJSXFactory('button', {className: this.settings.classes.base + "__btn-text " + this.settings.classes.base + "__btn-text--edit js-edit-details"}, ["Edit Details"]) : undefined,
                        file.id && this.settings.allowRemoving ? eotwJSXFactory('button', {className: this.settings.classes.base + "__btn-text js-remove", type: "button"}, ["Remove"]) : undefined,
                        eotwJSXFactory('span', {className: this.settings.classes.base + "__btn"}, [
                            eotwJSXFactory('span', {className: this.settings.classes.base + "__icon", unsafehtml: admin_svg_include('success')})
                        ])
                    ])
                ])
            ])
        ).data("file", file);
    }

    buildFullNameElement(file) {
        if (this.settings.allowEditFileName) {
            return eotwJSXFactory('strong', {className: "js-full-name"}, [file.label + " - ", " ", eotwJSXFactory('small', null, [file.fullName])]);
        } else {
            return eotwJSXFactory('strong', {className: "js-full-name"}, [file.fullName]);
        }
    }

    handleMouseDown($elem, e) {
        if (e.which !== 1) return;
        if (!this.settings.allowOrdering) return;

        this.handleMouseUp();

        this.$originalElement = $elem;
        this.$draggingElement = this.$originalElement.clone();
        this.$progressHolder.append(this.$draggingElement);


        this.$originalElement.addClass("admin-orderer__item--placeholder");
        this.$draggingElement.addClass("admin-orderer__item--dragging");

        $(window).on("mousemove", this.handleMouseMove).on("mouseup", this.handleMouseUp);
        this.handleMouseMove(e);
        return false;
    }

    handleMouseMove(e) {
        if (this.$draggingElement !== null) {
            let $dragged = this.$draggingElement;
            let pos = e.pageY - $dragged.parent().offset().top - ($dragged.height() / 2);
            $dragged.css("transform", "translateY(" + pos + "px)");

            let currentIndex = this.$originalElement.index();

            $dragged.siblings(".js-orderer-item").each((index, elem) => {
                let $el = $(elem);
                if ($el.is(".admin-orderer__item--placeholder") || $el.is(".admin-orderer__item--dragging")) return;

                let offset = $el.offset();
                offset.bottom = offset.top + $el.outerHeight();

                if (offset.top < e.pageY && e.pageY < offset.bottom) {
                    if (currentIndex > index) {
                        $el.before(this.$originalElement);
                    } else {
                        $el.after(this.$originalElement);
                    }
                    return false;
                }
            });
        } else {
            $(window).off("mousemove", this.handleMouseMove).off("mouseup", this.handleMouseUp);
        }
    }

    handleMouseUp(e = null) {
        if (e !== null && e.which !== 1) return;

        if (this.$draggingElement !== null) {
            this.$originalElement.removeClass("admin-orderer__item--placeholder");
            this.$draggingElement.remove();

            this.files = this.$progressHolder.children().map((_, el) => $(el).data("file")).get();
            this.emit("ordered", this.items);

            this.$originalElement = null;
            this.$draggingElement = null;
        }
        $(window).off("mousemove", this.handleMouseMove).off("mouseup", this.handleMouseUp);
    }

    async startFileUpload(data) {
        try {
            this.uploadingRequests[data.ID] = data;
            this.checkUploadingRequests();

            let chunkedUpload = data.context.data("chunkedUpload");
            if (!chunkedUpload) {
                this.displayLoading(data.context, 0);
                chunkedUpload = await FileUploader.create_chunked_upload(data.files[0]);
                data.context.data("chunkedUpload", chunkedUpload);
            }

            let attempts = data.context.data("attempts") || 0;
            data.context.data("attempts", attempts + 1);
            data.url = chunkedUpload.href;

            if (chunkedUpload.dateFinished !== null) {
                // File is already uploaded - just re-attempt processing
                this.displayLoading(data.context, 100);
                this.handleSuccessfulUpload(data);
            } else {
                data.uploadedBytes = chunkedUpload.uploadedSize;
                this.displayLoading(data.context, (chunkedUpload.uploadedSize / chunkedUpload) * 100);

                data.submit();
            }
        } catch (e) {
            console.error("Couldn't start chunked upload", e);
            this.displayError(data.context);
            this.emit(EVENT_FILE_ERROR, {
                message: e.message,
                file: data,
            });
            data.emitter.emit(EVENT_FILE_ERROR, {
                message: e.message,
                file: data,
            });

            delete this.uploadingRequests[data.ID];
            this.checkUploadingRequests();
        }
    }

    displayLoading($element, progress = null) {
        if (this.$progressHolder === null) {
            return;
        }

        $element.removeClass(this.settings.classes.base + "--progress-hidden");
        $element.removeClass(this.settings.classes.base + "--done " + this.settings.classes.base + "--error " + this.settings.classes.base + "--progress-hidden").find(".js-indicator").css("width", progress + "%");
        $element.find(".js-buttons").html(
            eotwJSXFactory('span', {className: this.settings.classes.base + "__btn"}, [
                eotwJSXFactory('span', {className: this.settings.classes.base + "__icon " + this.settings.classes.base + "__icon--loading"}, [
                    eotwJSXFactory('img', {src: window.CONFIG.urls.admin + "modules/gallery/images/svg/gallery-loader.svg", alt: ""})
                ])
            ]),
        );
    }

    displayError($element) {
        if (this.$progressHolder === null) {
            return;
        }

        $element.removeClass(this.settings.classes.base + "--progress-hidden");
        $element.addClass(this.settings.classes.base + "--error").find(".js-indicator").css("width", "100%");
        $element.find(".js-buttons").html([
            eotwJSXFactory('button', {className: this.settings.classes.base + "__btn-text js-retry"}, ["Retry"]),
            eotwJSXFactory('button', {className: this.settings.classes.base + "__btn js-remove"}, [
                eotwJSXFactory('span', {className: this.settings.classes.base + "__icon", unsafehtml: admin_svg_include('error')})
            ]),
        ]);
    }

    displaySuccess($element) {
        if (this.$progressHolder === null) {
            return;
        }

        $element.removeClass(this.settings.classes.base + "--progress-hidden");
        $element.addClass(this.settings.classes.base + "--done").find(".js-indicator").css("width", "100%");
        $element.find(".js-buttons").html([
            this.settings.allowEditFileName ? eotwJSXFactory('button', {className: this.settings.classes.base + "__btn-text " + this.settings.classes.base + "__btn-text--edit js-edit-details"}, ["Edit Details"]) : null,
            this.settings.allowRemoving ? eotwJSXFactory('button', {className: this.settings.classes.base + "__btn-text js-remove", type: "button"}, ["Remove"]) : null,
            eotwJSXFactory('span', {className: this.settings.classes.base + "__btn"}, [
                eotwJSXFactory('span', {className: this.settings.classes.base + "__icon", unsafehtml: admin_svg_include('success')})
            ]),
        ]);

        setTimeout(() => {
            $element.addClass(this.settings.classes.base + "--progress-hidden");
        }, 500);
    }


    handleProgress(e, data) {
        let progress = parseInt((data.loaded || 0) / data.total * 100, 10);
        data.context.find(".js-indicator").css("width", progress + "%");
        this.emit(EVENT_FILE_PROGRESS, {
            data,
            progress,
        });
        data.emitter.emit(EVENT_FILE_PROGRESS, {
            data,
            progress,
        });
    }

    static async create_chunked_upload(file) {
        return await Ajax.post("base", "chunked-uploads", {
            size: file.size,
            filename: file.name,
        }, window.User ? Ajax.ADMIN : Ajax.WEBSITE);
    }
}

FileUploader.CURRENT_ID = 0;

FileUploader.DEFAULT_SETTINGS = {
    allowMultiple: true,
    allowOrdering: false,
    allowEditFileName: false,
    allowRemoving: true,
    extensions: [],
    accept: null,
    classes: {
        base: "admin-file-progress",
    },
    uploaderSettings: {},
    chunkSize: 10 * 1000 * 1000, /* 10 MB */
};

export default FileUploader;

export const EVENT_FILE_ADDED = 'fileAdded';
export const EVENT_EXISTING_FILE_ADDED = 'existingFileAdded';
export const EVENT_FILE_REMOVED = 'fileRemoved';
export const EVENT_UPLOADING = 'uploading';
export const EVENT_FILE_UPLOADED = 'fileUploaded';
export const EVENT_DONE = 'done';
export const EVENT_FILE_ERROR = 'fileError';
export const EVENT_CHANGE = 'change';
export const EVENT_FILE_PROGRESS = 'fileProgress';
